export const YOUR_BARRIO_LOGO_VARIANTS = Object.freeze({
  "navbar-light": {
    src: "/brand/navbar-logo-light.svg",
    width: 245,
    height: 68,
  },
  "navbar-dark": {
    src: "/brand/navbar-logo-dark.svg",
    width: 245,
    height: 68,
  },
  "wordmark-light": {
    src: "/brand/wordmark-light.svg",
    width: 182,
    height: 36,
  },
  "wordmark-dark": {
    src: "/brand/wordmark-dark.svg",
    width: 182,
    height: 36,
  },
  "mark-purple": {
    src: "/brand/logo-mark-purple.svg",
    width: 272,
    height: 272,
  },
  "mark-white": {
    src: "/brand/logo-mark-white.svg",
    width: 272,
    height: 272,
  },
  "app-icon": {
    src: "/brand/app-icon.svg",
    width: 1024,
    height: 1024,
  },
});

export function getYourBarrioLogoSrc(variant = "navbar-dark") {
  return (YOUR_BARRIO_LOGO_VARIANTS[variant] || YOUR_BARRIO_LOGO_VARIANTS["navbar-dark"]).src;
}

export default function YourBarrioLogo({
  variant = "navbar-dark",
  alt = "YourBarrio",
  className = "",
  priority = false,
  width = undefined,
  height = undefined,
  size = undefined,
  sizes = undefined,
  ...props
}) {
  const config = YOUR_BARRIO_LOGO_VARIANTS[variant] || YOUR_BARRIO_LOGO_VARIANTS["navbar-dark"];
  const resolvedWidth = size || width || config.width;
  const resolvedHeight = size || height || config.height;

  return (
    <img
      src={config.src}
      alt={alt}
      width={resolvedWidth}
      height={resolvedHeight}
      sizes={sizes}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={priority ? "high" : undefined}
      className={`block object-contain ${className}`.trim()}
      {...props}
    />
  );
}
